import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { BannerComponent } from '@core/impact-tracker-smart-ui';
import { TELLENT_SUITE_ENABLED } from '@core/tellent-types';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { ImpactTrackerAnalytics } from '../impact-tracker.analytics';
import { ImpactTrackerService } from '../impact-tracker.service';

@Component({
  selector: 'tlc-impact-tracker-insights-banner',
  templateUrl: './impact-tracker-insights-banner.component.html',
  styleUrl: 'impact-tracker-insights-banner.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BannerComponent, ButtonComponent, IconComponent, TranslatePipe],
})
export class ImpactTrackerInsightsBannerComponent {
  private readonly tellentSuiteEnabled = inject(TELLENT_SUITE_ENABLED);
  protected readonly impactTrackerService = inject(ImpactTrackerService);
  protected readonly impactTrackerAnalytics = inject(ImpactTrackerAnalytics);
  protected readonly expirationInMs = 14 * 24 * 60 * 60 * 1000; // two weeks in ms

  protected isVisible = computed(
    () => this.impactTrackerService.data()?.showDialogBanner && this.tellentSuiteEnabled,
  );

  public ngOnInit(): void {
    this.impactTrackerService.fetchData();
  }

  protected openDialog(): void {
    this.impactTrackerAnalytics.trackDialogTriggered('banner');
    this.impactTrackerService.openDialog();
  }
}
